module.exports = __webpack_public_path__ + "static/feature-3-f2e4ef77f767851cc540abbb2a50826d.svg";